import moment from 'moment';

// Translate dates depending on locale to show day and month
const formatDatesToLocale = () => {
  const currentLocale = moment.locale(); // read current locale
  if (currentLocale) {
    switch (currentLocale) {
      case 'en':
        return 'Do MMMM';
      case 'es':
        return 'D MMMM';
      default:
        return 'D MMMM';
    }
  }
  return 'D MMMM';
};

export default formatDatesToLocale;
